import React from "react";

import { useSelector } from "react-redux";

import { Avatar } from "antd";

import { containsLink, formatDate, formatMessage } from "../../helper";
import styles from "./style.module.css";
import { baseUrl } from "../../services/api";
import UserIcon from "../../assets/images/user-icon.png";

const MessageCard = ({ message }) => {
  const loggedInUser = useSelector((state) => state.auth.user);

  const renderProfilePicture = () => {
    return (
      <Avatar
        className="shadow-sm"
        src={
          <img
            width={60}
            src={
              message?.receiverProfileUrl
                ? `${baseUrl}/${message?.receiverProfileUrl}`
                : UserIcon
            }
            alt="avatar"
          />
        }
      />
    );
  };

  return (
    <>
      <div className="d-flex border-bottom cursor_pointer">
        <div className={`${styles.singleMeeting} me-3`}>
          {/* <BiEnvelope color="white" size={20} /> */}
          {renderProfilePicture()}
        </div>
        <div className="flex-column d-flex font-size-13px">
          <span>
            From
            <b>
              <i>
                {" "}
                {message?.receiver_uuid === loggedInUser?.uuid
                  ? message?.senderName
                  : message?.receiverName}
              </i>
            </b>
          </span>

          <span style={{ color: "gray" }}>
            {formatDate(message?.timestamp.seconds * 1000)}
          </span>
          <span>
            {`${loggedInUser?.uuid === message?.sender_uuid ? "Me:" : ""}`}{" "}
            {containsLink(message?.text)
              ? "Shared zoom link"
              : formatMessage(message?.text, 5)}
          </span>
        </div>
      </div>

      {/* <hr /> */}
    </>
  );
};

export default MessageCard;
